import React from "react";
import { api } from "../api";

export default function SymbolPicker(props: { value: string; onChange: (s: string) => void; }) {
  const [syms, setSyms] = React.useState<string[]>([]);
  const [err, setErr] = React.useState<string | null>(null);

  React.useEffect(() => {
    (async () => {
      try { setSyms(await api.symbols()); }
      catch (e: any) { setErr(String(e)); }
    })();
  }, []);

  return (
    <div className="row">
      <label htmlFor="sym">Symbol:</label>
      <select id="sym" value={props.value} onChange={e => props.onChange(e.target.value)}>
        {syms.map(s => <option key={s} value={s}>{s}</option>)}
      </select>
      {err && <span className="bad">{err}</span>}
    </div>
  );
}
